import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
	fr: {
		header: {
			title: 'Piquage.com',
			motto: 'Les experts de la digitalisation en ligne.',
			order: 'Commander',
			more: 'En savoir plus'
		},
		footer: {
			termsAndConditions: 'CGV',
			legalMentions: 'Mentions Légales',
			privacyPolicy: 'Politique de confidentialité',
			contact: 'Contact',
			contactForm: {
				title: 'Contact',
				emailAddress: 'Adresse e-mail',
				emailPlaceholder: 'Entrez votre adresse e-mail...',
				messagePlaceholder: 'Entrez votre message...',
				filePlaceholder: 'Ajoutez un fichier...',
				fileDrop: 'Glissez votre fichier...',
				submit: 'Envoyer',
				success: 'Envoyé !'
			}
		},
		textBlock: {
			title: 'Notre expérience à votre service.',
			text: "Plus de 20 ans d'expérience.\nTous logiciels de broderie.\nQualité inégalée.\nLivraison 24/48h."
		},
		prices: {
			title: 'Tarifs.',
			embroidery: 'Digitalisation Broderie',
			vectorization: 'Vectorisation',
			modals: {
				XS: {
					title: 'Tarif XS',
					text: 'Le tarif XS correspond à un dessin de ',
					imgURL: '../assets/img/CoqSimple.png'
				},
				S: {
					title: 'Tarif S',
					text:
						'Le tarif S correspond à une broderie de moins de 25 cm2.<br><br>Pour calculer votre forfait, il suffit de multiplier la largeur par la hauteur totale de votre logo.<br><br>Ex. de forfait S : L 8 cm x H 3 cm = 24 cm2',
					imgURL: 'S.png'
				},
				M: {
					title: 'Tarif M',
					text:
						'Le tarif M correspond à une broderie de moins de 75 cm2.<br><br>Pour calculer votre forfait, il suffit de multiplier la largeur par la hauteur totale de votre logo.<br><br>Ex. de forfait M : L 9 cm x H 8 cm = 72 cm2',
					imgURL: 'M.png'
				},
				L: {
					title: 'Tarif L',
					text:
						'Le tarif L correspond à une broderie de moins de 150 cm2.<br><br>Pour calculer votre forfait, il suffit de multiplier la largeur par la hauteur totale de votre logo.<br><br>Ex. de forfait L : L 18 cm x H 8 cm = 144 cm2',
					imgURL: 'L.png'
				},
				XL: {
					title: 'Tarif XL',
					text:
						'Le tarif XL correspond à une broderie de plus de 150 cm2.<br><br>Pour calculer votre forfait, il suffit de multiplier la largeur par la hauteur totale de votre logo.<br><br>Ex. de forfait XL : L 28 cm x H 20 cm = 560 cm2',
					imgURL: 'XL.png'
				},
				V1: {
					title: 'Tarif V1',
					text:
						'Le tarif V1 correspond à une vectorisation très simple des contours de votre dessin. (Idéal pour plotter)',
					imgURL: 'CoqContour.png'
				},
				V2: {
					title: 'Tarif V2',
					text: "Le tarif V1 correspond à une vectorisation complète d'un dessin simple.",
					imgURL: 'CoqSimple.png'
				},
				V3: {
					title: 'Tarif V3',
					text: "Le tarif V2 correspond à une vectorisation complète d'un dessin moyennement complexe.",
					imgURL: 'CoqMedium.png'
				},
				V4: {
					title: 'Tarif V4',
					text: "Le tarif V3 correspond à une vectorisation complète d'un dessin complexe.",
					imgURL: 'CoqComplex.png'
				},

				close: 'Fermer'
			}
		},
		gallery: {
			gallery: 'Gallerie.'
		}
	},

	us: {
		header: {
			title: 'Piquage',
			motto: 'Your digitizing services provider',
			order: 'Order now',
			more: 'More...'
		},
		footer: {
			termsAndConditions: 'Terms and Conditions',
			legalMentions: 'Legal Mentions',
			privacyPolicy: 'Privacy Policy',
			contact: 'Contact Us',
			contactForm: {
				title: 'Contact Us',
				emailAddress: 'Email',
				emailPlaceholder: 'Enter your email...',
				messagePlaceholder: 'Enter your message...',
				filePlaceholder: 'Select a file to upload...',
				fileDrop: 'Drop file...',
				submit: 'Send',
				success: 'Sent!'
			}
		},
		textBlock: {
			title: 'Expect the best.',
			text: '20+ years of experience.\nAny embroidery format.\nUnmatched quality.\n24/48hr delivery.'
		},
		prices: {
			title: 'Prices.',
			embroidery: 'Embroidery Digitizing',
			vectorization: 'Vectorization',
			modals: {
				XS: {
					title: 'Tarif XS',
					text: '',
					imgURL: 'dummyimg.jpg'
				},
				S: {
					title: 'Tarif S',
					text: '',
					imgURL: 'dummyimg.jpg'
				},
				M: {
					title: 'Tarif M',
					text: '',
					imgURL: 'dummyimg.jpg'
				},
				L: {
					title: 'Tarif L',
					text: '',
					imgURL: 'dummyimg.jpg'
				},
				XL: {
					title: 'Tarif XL',
					text: '',
					imgURL: 'dummyimg.jpg'
				},
				V1: {
					title: 'Tarif V1',
					text: '',
					imgURL: 'CoqContour.png'
				},
				V2: {
					title: 'Tarif V2',
					text: '',
					imgURL: 'CoqSimple.png'
				},
				V3: {
					title: 'Tarif V3',
					text: '',
					imgURL: 'CoqMedium.png'
				},
				V4: {
					title: 'Tarif V4',
					text: '',
					imgURL: 'CoqComplex.png'
				},
				close: 'Close'
			}
		},
		gallery: {
			gallery: 'Gallery.'
		}
	}
};

const i18n = new VueI18n({
	locale: 'fr', // set locale
	fallbackLocale: 'fr', // set fallback locale
	messages // set locale messages
});

export default i18n;
